import { ReferenceChatType } from '@/entities/project/api/generated/model';
import { trackEvent, UmamiEvent, type UmamiEventName } from '@/shared/lib/umami';
import type { ProjectReferenceChatType } from './types';

// chat_type × 初回/再実行 のマッピング。
// 「バラバラに集計したい」要件のため複数イベントに展開している（umami.ts UmamiEvent 参照）。
const eventMap: Record<ProjectReferenceChatType, { first: UmamiEventName; re: UmamiEventName }> = {
  [ReferenceChatType.national_grants]: {
    first: UmamiEvent.NATIONAL_GRANTS_MATCH_EXECUTED,
    re: UmamiEvent.NATIONAL_GRANTS_MATCH_RE_EXECUTED,
  },
  [ReferenceChatType.prefectural_grants]: {
    first: UmamiEvent.PREFECTURAL_GRANTS_MATCH_EXECUTED,
    re: UmamiEvent.PREFECTURAL_GRANTS_MATCH_RE_EXECUTED,
  },
  [ReferenceChatType.prefectural_special_allocation_taxes]: {
    first: UmamiEvent.PREFECTURAL_SPECIAL_ALLOCATION_TAXES_MATCH_EXECUTED,
    re: UmamiEvent.PREFECTURAL_SPECIAL_ALLOCATION_TAXES_MATCH_RE_EXECUTED,
  },
};

/**
 * 事業詳細画面の AI 分析実行を Umami へ送信する。
 *
 * - 同一事業で何回叩いたかを集計するため `project_id` を data に付与
 * - 再実行（既存結果がある状態での execute）は別イベント名で発火
 */
export const trackReferenceChatExecuted = (args: {
  chatType: ProjectReferenceChatType;
  isReExecution: boolean;
  projectId: string;
}): void => {
  const eventName = args.isReExecution ? eventMap[args.chatType].re : eventMap[args.chatType].first;
  trackEvent(eventName, { project_id: args.projectId });
};
